import { reduce, keys } from 'lodash/fp'
import {
  FormFieldDescriptor,
  FormFieldDescriptorDeclaration,
} from '@/interfaces'

const normalizeFormConfiguration: (configuration: {
  [key: string]: FormFieldDescriptorDeclaration
}) => {
  [key: string]: FormFieldDescriptor
} = (configuration: { [key: string]: FormFieldDescriptorDeclaration }) =>
  reduce(
    (fields, key: string) => ({
      ...fields,
      [key]: {
        ...configuration[key],
        error: null,
        name: key,
        serverName: configuration[key].serverName || key,
        state: 'pristine',
        value: configuration[key].initial,
      },
    }),
    {},
    keys(configuration),
  )

export default normalizeFormConfiguration
